import Box from "./Box";
import CalloutBlock from "./CalloutBlock";
import EmbedBlock from "./EmbedBlock";
import React from "react";
import ResponsiveImage from "./ResponsiveImage";
import RichText from "./RichText";

function BlogArticleContent({ content }) {
  return (
    <>
      {content.map((block, index) => {
        let blockComponent;
        if (block.type === "text") {
          blockComponent = <RichText>{block.value}</RichText>;
        } else if (block.type === "image") {
          blockComponent = (
            <ResponsiveImage
              resizeRule="width-1280"
              image={block.value}
              pb={`${(block.value.height / block.value.width) * 100}%`}
            />
          );
        } else if (block.type === "embed") {
          blockComponent = <EmbedBlock value={block.value} />;
        } else if (block.type === "callout") {
          blockComponent = <CalloutBlock value={block.value} />;
        }
        return (
          <Box key={index} mt={[30, null, index === 0 ? 40 : 90, null]}>
            {blockComponent}
          </Box>
        );
      })}
    </>
  );
}

export default BlogArticleContent;
